import React from 'react';
import { SvgIcon } from "@adsk/bim360-matrix-react-components";
import closedStateIcon from "../../../../../assets/images/icons/icon-closed-state.svg";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ProgressIndicatorBullets = ({ bulletNumber, completed, isSmall }) => {
  if (completed === bulletNumber) {
    return <SvgIcon width={20} height={20}>{closedStateIcon}</SvgIcon>;
  }
  return (
    <div className={classNames("ProgressIndicatorBullets", { "ProgressIndicatorBullets--small": isSmall })}>
      {Array(bulletNumber).fill().map((_, i) =>
        <span key={`ProgressIndicatorBullets__bullet${i}`} className={classNames('ProgressIndicatorBullets__bullet', { 'ProgressIndicatorBullets__bullet--completed': i < completed })} >{'\u2b24'}</span>)
      }
    </div>
  );
};

ProgressIndicatorBullets.propTypes = {
  bulletNumber: PropTypes.number.isRequired,
  completed: PropTypes.number.isRequired,
  isSmall: PropTypes.bool,
};
export default ProgressIndicatorBullets;
